<template>
  <div>
    <on-board-top-navbar />
    <step-signal />
    <!-- bottom-navbar encima de content para fix de padding bottom-->
    <on-board-bottom-navbar />
    <div class="on-board-content">
      <timon />
      <router-view></router-view>
      <OnboardSideBox></OnboardSideBox>
    </div>
    
</div>
</template>

<script>
import Timon from '@/components/on-board/Timon'
import OnboardSideBox from '@/components/on-board/OnboardSideBox'
import StepSignal from '@/components/on-board/StepSignal.vue'
import OnBoardBottomNavbar from '@/components/on-board/OnBoardBottomNavbar'
import OnBoardTopNavbar from '@/components/on-board/OnBoardTopNavbar'
import LanguageAlertModal from '@/components/on-board/LanguageAlertModal'

export default {
  name: 'OnboardStep',
  components: {
    OnBoardBottomNavbar,
    OnBoardTopNavbar,
    StepSignal,
    Timon,
    OnboardSideBox
  },
  methods: {
    goToLicitador() {
      this.$router.push({ name: 'onBoard.licitador.first' })
    },
    goToNeofintech() {
      this.$router.push({ name: 'onBoard.neofintech.first' })
    },
    showLanguageAlertModal() {
      let self = this
      self.$dlg.modal(LanguageAlertModal, {
        shaking: false,
        title: false,
        params: {
          title: '',
          bgColor: '#de4281',
          content: ``,
          confirmText: self.$t('Aceptar')
        }
      })
    },
  },
  computed: {},
  data: () => ({}),
  mounted() {
    this.$store.commit('layout/FULL_PAGE', true)
    this.$store.commit('layout/IS_ASIDE_WIDE_ACTIVE', false)
    localStorage.setItem('visitedRoutes', "")
    !localStorage.getItem('locale') && this.showLanguageAlertModal()
  },
  beforeDestroy() {
    this.$store.commit('layout/FULL_PAGE', false)
  }
}
</script>

<style lang="scss" scoped>
#ecovideo {
  position: fixed;
  height: 100vw;
  left: 0;
  opacity: 0.5;
  filter: blur(10px) saturate(0.6);
  object-fit: cover;
}

.dropdown-menu {
  top: auto;
  bottom: 100%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.on-board-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}
.on-board-content > div {
  width: 100%;
  height: 100%;
  margin: auto;
}
/* Fix padding bottom */
@media (max-width: 1024px) {
  #bottom-navbar + .on-board-content  {
    padding-bottom: 65px;
  }
}
#top-navbar ~ .on-board-content  {
  // padding-top: 60px;
}

// @media (max-width: 1024px) {
//   .on-board-content {
//     padding-top: 65px;
//   }
// }
</style>
